import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import Button from '../Button';
import Modal from '../Modal';

const ContactDeleteDialog = ({ onConfirm, onCancel, isLoading, name }) => {
  const { t } = useTranslation('components');

  return (
    <Modal
      title={t('ContactDeleteDialog.title', { name })}
      showCloseButton
      onClickCloseButton={onCancel}
    >
      <div className="mb-6">{t('ContactDeleteDialog.text')}</div>
      <footer className="flex justify-center">
        <Button isLoading={isLoading} onClick={onConfirm}>
          {t('ContactDeleteDialog.confirm')}
        </Button>
      </footer>
    </Modal>
  );
};

ContactDeleteDialog.propTypes = {
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func,
  isLoading: PropTypes.bool,
  name: PropTypes.string.isRequired,
};

ContactDeleteDialog.defaultProps = {
  onConfirm: () => {},
  onCancel: () => {},
  isLoading: false,
};

export default ContactDeleteDialog;
